import { PayloadAction } from '../../../store.model';
import { INITIAL_MAX_ROWS } from '../fixture/initial-max-rows';
import { createNextGridState } from '../function/create-next-grid-state.function';
import { filterRows } from '../function/filter-rows.function';
import { sortRows } from '../function/sort-rows.function';
import { toggleObjectsForArray } from '../function/toggle-objects-for-array.function';
import { ActionType } from '../landing.action';
import { LandingState } from '../landing.state';
import { SelectedFilterOption } from '../model/filter-criteria-item.model';

import { FilterRows } from './filter-rows.action';

export function filterRowsReducer(
    state: LandingState,
    action: PayloadAction<ActionType.EVAL_LANDING__FILTER_ROWS, FilterRows>,
): LandingState {
    const nextState: LandingState = { ...state };

    try {
        const ngo = createNextGridState(action.payload.grid, state, nextState);

        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const filterCriteriaItem = toggleObjectsForArray(
            ngo.selectedFilterOptions ?? [],
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            {
                columnId: action.payload.columnId,
                value: action.payload.value,
            } as SelectedFilterOption,
        );
        let nextFilteredRows = filterRows(ngo.rows, filterCriteriaItem);
        ngo.selectedFilterOptions = filterCriteriaItem;
        nextFilteredRows = sortRows(nextFilteredRows, ngo.sortOptions);
        ngo.showAllEnabled = nextFilteredRows.length > INITIAL_MAX_ROWS;
        nextFilteredRows = nextFilteredRows.slice(
            0,
            ngo.showAll ? ngo.rows.length : INITIAL_MAX_ROWS,
        );

        ngo.filteredRows = nextFilteredRows;
    } catch {}

    return nextState;
}
